const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:4000/api";

/**
 * POST /api/v2/provision-line
 * Creates (or returns the existing) Twilio subaccount and phone number for this
 * V2 user. Idempotent: safe to call more than once.
 */
export async function provisionLine(user, propertyAddress = "") {
  const token = await user.getIdToken();
  const response = await fetch(`${API_URL}/v2/provision-line`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ propertyAddress }),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.error || `Provision failed (${response.status})`);
  }

  return response.json();
}

/**
 * GET /api/v2/provision-line/status
 * Non-mutating check: returns current provisioning state for this user.
 */
export async function getProvisionStatus(user) {
  const token = await user.getIdToken();
  const response = await fetch(`${API_URL}/v2/provision-line/status`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.error || `Status check failed (${response.status})`);
  }

  return response.json();
}
